import { useEffect, useState } from 'react'
import { getMenus } from '../../../api/menusApi';

import TopBar from '../../../components/TopBar'
import FooterWidgetBlock from '../../../components/Appearance/FooterWidgetBlock'

import styles from '../page.module.css'
import { getOption, updateOption } from '../../../api/optionsApi';

const MenuFooter = () => {
  
  const [menuList, setMenuList] = useState([]);
  const [isLoading, setIsLoading] = useState(false)

  const [footerTopBlock, setFooterTopBlock] = useState({
    aboutMalmart: "",
    menus: [
      { title: "", menuId: "", menuTitle: "" },
      { title: "", menuId: "", menuTitle: "" },
      { title: "", menuId: "", menuTitle: "" },
      { title: "", menuId: "", menuTitle: "" },
    ]
  });

  const [footerBottomBlock, setFooterBottomBlock] = useState({
    contactUs1: {title: "", data: ""},
    contactUs2: {title: "", data: ""},
    menus: [
      { title: "", menuId: "", menuTitle: "" },
      { title: "", menuId: "", menuTitle: "" },
      { title: "", menuId: "", menuTitle: "" },
    ],
    socialMediaUrl: {
      playStore: '',
      appleStore: '',
      linkedin: '',
      twitter: '',
      instagram: '',
      facebook: ''
    }
  });

  const loadMenus = async () => {
      try {
        const response = await getMenus();

        if (response?.data?.length > 0) {
            setMenuList(response.data);
        }
      } catch (error) {
          console.error('Failed to load menus', error);
      }
  };

  useEffect(() => {
      loadMenus();
  }, []);

  useEffect(() => {
      const loadData = async () => {
          try {
              const footerTopData = await getOption("footer-top");
              const footerBottomData = await getOption("footer-bottom");

              if(footerTopData?.data?.value){
                setFooterTopBlock(footerTopData.data.value)
              }
              if(footerBottomData?.data?.value){
                setFooterBottomBlock(footerBottomData.data.value)
              }
          } catch (error) {
              console.error("Error loading data:", error);
          }
      };
      loadData();

  }, []);

  const handleSave = async () => {
    setIsLoading(true)
    try {
      await updateOption("footer-top", footerTopBlock);
      await updateOption("footer-bottom", footerBottomBlock);
    } catch (error) {
      console.error("Error saving:", error);
    } finally {
      setIsLoading(false)
    }
  };

  return (
    <>
      <TopBar />
      <div className={styles.appearanceMenuSection}>
        <div className={styles.appearanceMenuBox}>
          <div className={styles.appearanceMenuBlock}>
            <div className={styles.appearanceMenuLeft}>
              <label className={styles.appearanceMenuBoxLabel}>Footer Top Block</label>

              <div className={styles.appearanceMenuWidgetBlock}>
                <label>About Malmart</label>
                <p className={styles.appearanceMenuDescription}>
                  This content appears on the <strong>about us of the bottom</strong> on the website. You may use <strong>HTML</strong> such as links, icons, or formatting.
                </p>
                <textarea
                  className={styles.appearanceMenuTextArea}
                  value={footerTopBlock.aboutMalmart}
                  onChange={(e) =>
                    setFooterTopBlock({
                      ...footerTopBlock,
                      aboutMalmart: e.target.value
                    })
                  }
                />
              </div>

              {footerTopBlock.menus.map((item, index) => (
                <FooterWidgetBlock
                  key={index}
                  menuList={menuList}
                  data={item}
                  index={index}
                  onClick={(updatedData) => {
                    const copy = {
                      ...footerTopBlock,
                      menus: [...footerTopBlock.menus]
                    };
                    copy.menus[index] = updatedData;
                    setFooterTopBlock(copy);
                  }}
                />
              ))}
            </div>

            <div className={styles.appearanceMenuRight}>
              <label className={styles.appearanceMenuBoxLabel}>Footer Bottom Block</label>
              <div className={styles.appearanceMenuWidgetBlock}>
                <label>Contact Malmart 1</label>
                <p className={styles.appearanceMenuDescription}>
                  This content appears on the <strong>contact detail of the bottom</strong> on the website. You may use <strong>HTML</strong> such as links, icons, or formatting.
                </p>
                <input
                  type="text"
                  className={styles.footerTitleInput}
                  placeholder="Enter title..."
                  value={footerBottomBlock.contactUs1?.title || ''}
                  onChange={(e) =>
                      setFooterBottomBlock({
                        ...footerBottomBlock,
                        contactUs1: { ...footerBottomBlock.contactUs1, title: e.target.value }
                      })
                  }
                />
                <textarea
                  className={styles.appearanceMenuTextArea}
                  value={footerBottomBlock.contactUs1?.data || ''}
                  onChange={(e) =>
                    setFooterBottomBlock({
                      ...footerBottomBlock,
                      contactUs1: { ...footerBottomBlock.contactUs1, data: e.target.value }
                    })
                  }
                />
              </div>

              <div className={styles.appearanceMenuWidgetBlock}>
                <label>Conatct Malmart 2</label>
                <p className={styles.appearanceMenuDescription}>
                  This content appears on the <strong>contact detail of the bottom</strong> on the website. You may use <strong>HTML</strong> such as links, icons, or formatting.
                </p>
                <input
                  type="text"
                  className={styles.footerTitleInput}
                  placeholder="Enter title..."
                  value={footerBottomBlock.contactUs2?.title || ''}
                  onChange={(e) =>
                      setFooterBottomBlock({
                        ...footerBottomBlock,
                        contactUs2: { ...footerBottomBlock.contactUs2, title: e.target.value }
                      })
                  }
                />
                <textarea
                  className={styles.appearanceMenuTextArea}
                  value={footerBottomBlock.contactUs2?.data || ''}
                  onChange={(e) =>
                    setFooterBottomBlock({
                      ...footerBottomBlock,
                      contactUs2: { ...footerBottomBlock.contactUs2, data: e.target.value }
                    })
                  }
                />
              </div>

              {footerBottomBlock.menus.map((item, index) => (
                <FooterWidgetBlock
                  key={index}
                  menuList={menuList}
                  data={item}
                  index={index}
                  onClick={(updatedData) => {
                    const copy = {
                      ...footerBottomBlock,
                      menus: [...footerBottomBlock.menus]
                    };
                    copy.menus[index] = updatedData;
                    setFooterBottomBlock(copy);
                  }}
                />
              ))}

              <div className={styles.footerLinkBlock}>
                <label>Column 6</label>
                <div className={styles.footerLinkInputSection}>
                  <div className={styles.footerLinkInputBlock}>
                    <input className={styles.footerTitleInput}
                      placeholder="Play Store URL"
                      value={footerBottomBlock?.socialMediaUrl?.playStore}
                      onChange={(e) =>
                        setFooterBottomBlock({
                          ...footerBottomBlock,
                          socialMediaUrl: {
                            ...footerBottomBlock?.socialMediaUrl,
                            playStore: e.target.value
                          }
                        })
                      }
                    />
                    <input className={styles.footerTitleInput}
                      placeholder="Apple Store URL"
                      value={footerBottomBlock?.socialMediaUrl?.appleStore}
                      onChange={(e) =>
                        setFooterBottomBlock({
                          ...footerBottomBlock,
                          socialMediaUrl: {
                            ...footerBottomBlock?.socialMediaUrl,
                            appleStore: e.target.value
                          }
                        })
                      }
                    />
                  </div>
                  <div className={styles.footerLinkInputBlock}>
                    <input className={styles.footerTitleInput}
                      placeholder="Instagram URL"
                      value={footerBottomBlock?.socialMediaUrl?.instagram}
                      onChange={(e) =>
                        setFooterBottomBlock({
                          ...footerBottomBlock,
                          socialMediaUrl: {
                            ...footerBottomBlock?.socialMediaUrl,
                            instagram: e.target.value
                          }
                        })
                      }
                    />
                    <input className={styles.footerTitleInput}
                      placeholder="LinkedIn URL"
                      value={footerBottomBlock?.socialMediaUrl?.linkedin}
                      onChange={(e) =>
                        setFooterBottomBlock({
                          ...footerBottomBlock,
                          socialMediaUrl: {
                            ...footerBottomBlock?.socialMediaUrl,
                            linkedin: e.target.value
                          }
                        })
                      }
                    />
                  </div>
                  <div className={styles.footerLinkInputBlock}>
                    <input className={styles.footerTitleInput}
                      placeholder="Twitter URL"
                      value={footerBottomBlock?.socialMediaUrl?.twitter}
                      onChange={(e) =>
                        setFooterBottomBlock({
                          ...footerBottomBlock,
                          socialMediaUrl: {
                            ...footerBottomBlock?.socialMediaUrl,
                            twitter: e.target.value
                          }
                        })
                      }
                    />
                    <input className={styles.footerTitleInput}
                      placeholder="Facebook URL"
                      value={footerBottomBlock?.socialMediaUrl?.facebook}
                      onChange={(e) =>
                        setFooterBottomBlock({
                          ...footerBottomBlock,
                          socialMediaUrl: {
                            ...footerBottomBlock?.socialMediaUrl,
                            facebook: e.target.value
                          }
                        })
                      }
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className={styles.saveButtons}>
            <button className={`${styles.saveButton} ${styles.saveChangeButton}`} onClick={() => handleSave()}>
              {isLoading ? <div className='ringLoader'></div> : 'Save Changes'}
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default MenuFooter;
